import React, { useState } from 'react';
import '../../styles/About.css';
import { Link } from 'react-router-dom';
import { FaLinkedin } from 'react-icons/fa';

export default function Secretariat() {
    const [staffMembers, setStaffMembers] = useState([
        {
            id: 7,
            name: "Andrea Lewis-Francis",
            role: "BUSINESS SUPPORT OFFICER",
            image: "https://www.canto.org/wp-content/uploads/2020/03/ANDREA-LEWIS-e1674743634181.jpg",
            link: 'https://www.linkedin.com/in/andrea-lewis-francis-9990b158/ '
        },
        {
            id: 8,
            name: "Jenelle Edwards",
            role: "BUSINESS OPERATIONS OFFICER",
            image: "https://www.canto.org/wp-content/uploads/2020/03/JENELLE-EDWARDS-e1674745194776.jpg",
            link: 'https://www.linkedin.com/in/jenelle-edwards/ ',
            break: false,
        },
        {
            id: 6,
            name: "Devika Flemming",
            role: "BUSINESS SUPPORT OFFICER",
            image: 'https://ts.canto.org/data/images/Devika_Flemming.JPG',
            link: 'https://ts.canto.org/data/images/Chrisal_Martin.JPG',
            break: false,
        },
        {
            id: 9,
            name: "Chrisal Martin",
            role: "SALES & MARKETING OFFICER",
            image: 'https://ts.canto.org/data/images/Chrisal_Martin.JPG',
            link: 'https://www.linkedin.com/in/chrisalmartin/ ',
            break: false,
        }
    ]);
  

    function renderBoardMembers(){
    
        const render_board_members = staffMembers.map((member, index) => 
            <Link to={member.link} target='_blank' className='board-member-new' onClick={() => {

            }}>
                <div className='board-member-photo' style={{backgroundImage: `url(${member.image})`,
                    backgroundSize: 'cover',}}
                ></div>
                
                <div className='board-member-content' style={{justifyContent: 'space-between'}}>
                    <div className='board-member-title'>{member.name} <FaLinkedin size={18} color='#0072b1' style={{marginLeft: '8px'}}/></div>
                    <div className='board-member-subrole'>{member.role}</div>
                    
                </div>
            </Link>
        )

        return render_board_members;

    }

    return (
        <div style={{paddingTop: '100px'}}>
            <div className='board-header'>
                Meet our Secretariat Staff
            </div>
            <div className='about-board-members-container-new' style={{flexWrap: 'wrap', padding: '50px 0'}}>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                    <Link to={'https://www.linkedin.com/in/teresa-wankin-59a2b155/'} target='_blank' className='board-member-new' onClick={() => {

                    }}>
                        <div className='board-member-photo' style={{backgroundImage: `url('https://www.canto.org/wp-content/uploads/2020/03/TERESA-WEBSITE-e1674743684270.jpg')`,
                            backgroundSize: 'cover',}}
                        ></div>
                        
                        <div className='board-member-content' style={{justifyContent: 'space-between'}}>
                            <div className='board-member-title'>Teresa Wankin <FaLinkedin size={18} color='#0072b1' style={{marginLeft: '8px'}}/></div>
                            <div className='board-member-subrole'>SECRETARY GENERAL</div>
                            
                        </div>
                    </Link>
                </div>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                        {[ 
                            {
                                id: 3,
                                name: "Jimmy Rodrigues",
                                role: "FINANCE AND ADMINISTRATION MANAGER",
                                image: "https://www.canto.org/wp-content/uploads/2020/03/JIMMY-RODRIGUES-e1674743855547.jpg",
                                link: 'https://www.linkedin.com/in/jimmy-rodrigues-2a61a73/',
                            },
                            {
                                id: 4,
                                name: "Lianne Dieffenthaller",
                                role: "OPERATIONS MANAGER",
                                image: "https://www.canto.org/wp-content/uploads/2020/03/LIANNE-DIFENTHALLER-e1674743820407.jpg",
                                link: 'https://www.linkedin.com/in/ldieffenthaller/',
                            },
                            {
                                id: 5,
                                name: "Nicole Freakley",
                                role: "BUSINESS DEVELOPMENT MANAGER",
                                image: "https://www.canto.org/wp-content/uploads/2020/03/NICOLE-FREAKLEY-e1674743737766.jpg",
                                link: 'https://www.linkedin.com/in/nicole-freakley-7a62b642/',
                            }
                        ].map(member => (
                            <Link key={member.id} to={member.link} target='_blank' className='board-member-new'>
                                <div className='board-member-photo' style={{backgroundImage: `url(${member.image})`, backgroundSize: 'cover'}}></div>
                                <div className='board-member-content' style={{justifyContent: 'space-between'}}>
                                    <div className='board-member-title'>{member.name} <FaLinkedin size={18} color='#0072b1' style={{marginLeft: '8px'}}/></div>
                                    <div className='board-member-subrole'>{member.role}</div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
                {renderBoardMembers()}
            </div>
        </div>
    )
}
